import { type MouseEventHandler } from 'react';

export interface ButtonProps {
  /** Button label text */
  label: string;
  /** Visual theme */
  theme?: 'primary' | 'secondary' | 'tertiary' | 'success' | 'danger';
  /** Size variant */
  size?: 'small' | 'default';
  /** Click handler */
  onClick?: MouseEventHandler<HTMLButtonElement>;
  /** Icon name — only "arrow-right" is supported, renders as Material Symbols arrow_forward */
  icon?: string;
  /** Icon position relative to label */
  iconPosition?: 'start' | 'end';
  /** Additional CSS class names */
  className?: string;
  /** Disabled state */
  disabled?: boolean;
}

const THEME_CLASS_MAP: Record<string, string> = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  tertiary: 'btn-ghost',
  success: 'btn-success',
  danger: 'btn-danger',
};

const ICON_MAP: Record<string, string> = {
  'arrow-right': 'arrow_forward',
};

export function Button({
  label,
  theme,
  size,
  onClick,
  icon,
  iconPosition = 'start',
  className,
  disabled,
}: ButtonProps) {
  const classes = [
    'btn',
    theme ? THEME_CLASS_MAP[theme] : undefined,
    size === 'small' ? 'btn-sm' : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const iconElement = icon ? (
    <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>
      {ICON_MAP[icon] ?? icon}
    </span>
  ) : null;

  return (
    <button className={classes} onClick={onClick} disabled={disabled}>
      {iconPosition === 'start' && iconElement}
      {label}
      {iconPosition === 'end' && iconElement}
    </button>
  );
}

export default Button;
